import { logger } from '@gem/modules/logger';

import { IClientConfigProperty } from 'APP/model/auth/authModel.types';
import Entities from 'STORE';
import { ClientConfigStoreKey } from 'STORE/ClientConfig/ClientConfig';

export function handleTelegramConfig(property: IClientConfigProperty): void {
  try {
    const { uri, token } = JSON.parse(property.value);

    Entities.clientConfig.setConfig(ClientConfigStoreKey.TelegramConfigToken, token);
    Entities.clientConfig.setConfig(ClientConfigStoreKey.TelegramConfigUri, uri);
  } catch (error) {
    logger.get('Tasks').error('login.clientConfig.telegram', error);
  }
}
